import {
  BillingType,
  type BillingAccountExtendedResponse,
} from '../../repositories/account-repo/schemas/billing-account-extended.zod';
import { getCurrencySymbol } from '../get-currency-symbol';

export class BillingAccountExtended {
  constructor(private apiResponse: BillingAccountExtendedResponse) {}

  public getCustomerId() {
    return this.apiResponse.customerId;
  }

  public getCurrency() {
    return this.apiResponse.currencyCd;
  }

  public getCurrencySymbol() {
    return getCurrencySymbol(this.getCurrency());
  }

  public shouldBlockBilling() {
    return this.isSingleBilled() || this.isPartnerBilled();
  }

  public isPartnerBilled() {
    return this.apiResponse.billingType.name === BillingType.PARTNER_BILLED;
  }

  public isSingleBilled() {
    return this.apiResponse.billingType.name === BillingType.SINGLE_BILLED;
  }

  public isRegularBilled() {
    return this.apiResponse.billingType.name === BillingType.REGULAR_BILLED;
  }

  public isNoBillingSystem() {
    return this.apiResponse.billingType.name === BillingType.NO_BILLING_SYSTEM;
  }

  public getIsSuspended() {
    return this.apiResponse.suspended;
  }
}
